import React, { useContext } from 'react';
import { ProgressionBar } from '../../../progression-bar/index.js';
import { ExerciseTranslationsContext } from '../../contexts/ExerciseTranslationsContext.js';
import { ExerciseDialogsContext } from '../../../../context/ExerciseDialogsContext.js';
import { ModalDialog, Dialog } from '../../../dialog/index.js';
import { Button } from '../../../button/index.js';
import { getScoreAsPercentage } from '../../util/score-utils.js';
import { ExerciseManagerContext } from '../../contexts/ExerciseManagerContext.js';

const ExerciseRestartDialog = ({ onClose, onReview, onRestart, result, }) => {
    const translations = useContext(ExerciseTranslationsContext);
    const dialogContext = useContext(ExerciseDialogsContext);
    const percentage = getScoreAsPercentage(result.score.achieved, result.score.achievable);
    const { showScore } = useContext(ExerciseManagerContext);
    const { session } = result;
    return (React.createElement(ModalDialog, { id: 'exercise-restart-dialog', onClose: onClose, closeTitle: translations.closeDialog, closeViaEscape: true, className: 'exercise-dialogs' },
        React.createElement(Dialog.Header, { title: translations.exerciseRestartDialog.title, startAdornment: dialogContext.header.iconClassName ? (React.createElement("i", { className: dialogContext.header.iconClassName, role: 'img' })) : (undefined) }),
        React.createElement(Dialog.Body, { "data-testid": 'exercise-restart-body' },
            showScore && (React.createElement("p", null,
                translations.exerciseResumeDialog.scorePrefix,
                React.createElement("b", null,
                    percentage,
                    "%"),
                ".")),
            React.createElement("p", null, onRestart
                ? translations.exerciseRestartDialog.message.p1.restartable
                : translations.exerciseRestartDialog.message.p1.nonRestartable),
            !showScore && React.createElement("p", null, translations.exerciseRestartDialog.result),
            React.createElement(ProgressionBar, { maximum: result.score.maximum, achievable: result.score.achievable, achieved: result.score.achieved, translations: translations.progressionBar })),
        React.createElement(Dialog.Footer, { "data-testid": 'exercise-restart-footer' },
            React.createElement(Button, { variant: 'secondary', onClick: onClose }, translations.exerciseRestartDialog.buttons.cancel),
            onReview && session && (React.createElement(Button, { variant: 'secondary', onClick: () => onReview(session) }, translations.exerciseRestartDialog.buttons.review)),
            onRestart && (React.createElement(Button, { variant: 'primary', onClick: onRestart }, translations.exerciseRestartDialog.buttons.restart)))));
};

export { ExerciseRestartDialog };
